import React from 'react';
import { Alert } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Standard error alert component
 */
const StandardErrorAlert = ({ children, sx, ...otherProps }) => {
  return (
    <Alert 
      severity="error" 
      sx={{ 
        mb: 3,
        ...sx
      }}
      {...otherProps}
    >
      {children}
    </Alert>
  );
};

StandardErrorAlert.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};

export default StandardErrorAlert;